import React from "react"
import { Box, Typography } from "@mui/material"
import { reportFormData } from "Pages/ReportsAlerts/Reports/@signals"


export default function ReportFormHeaderTitle() {
	const { title } = reportFormData.peek()
	return <Box>
		<Typography variant="h6" sx={{ fontWeight: 'bold', p: 1 }}>{title || "Create Report: New Report"}</Typography>
	</Box>
}